module.exports = __webpack_public_path__ + "static/media/IMG_2190.87f0d914.jpg";